// LLM Configuration
// Change these settings based on your preferred LLM provider

export const LLM_CONFIG = {
  // Options: 'ollama', 'openai', 'huggingface', 'lmstudio'
  provider: 'ollama' as 'ollama' | 'openai' | 'huggingface' | 'lmstudio',
  
  // Ollama settings (local, free, open-source)
  ollama: {
    apiUrl: 'http://localhost:11434/api/chat',
    model: 'llama2', // Options: llama2, llama3, mistral, phi, gemma, etc.
  },
  
  // OpenAI settings (cloud, paid)
  openai: {
    apiUrl: 'https://api.openai.com/v1/chat/completions',
    apiKey: process.env.REACT_APP_OPENAI_API_KEY || '', // Set in .env file
    model: 'gpt-3.5-turbo', // Options: gpt-3.5-turbo, gpt-4, etc.
  },
  
  // Hugging Face settings (cloud, free tier available)
  huggingface: {
    apiUrl: 'https://api-inference.huggingface.co/models/meta-llama/Llama-2-7b-chat-hf',
    apiKey: process.env.REACT_APP_HF_TOKEN || '', // Set in .env file
  },
  
  // LM Studio settings (local, free, OpenAI-compatible)
  lmstudio: {
    apiUrl: 'http://localhost:1234/v1/chat/completions',
    model: 'local-model', // The model name from LM Studio
  },
  
  // System prompt for health coaching
  systemPrompt: `You are a knowledgeable and empathetic health coach specializing in diabetes management. 
Your role is to:
- Provide supportive, evidence-based guidance on diabetes care
- Help users understand blood sugar management, diet, exercise, and medication
- Encourage healthy lifestyle choices
- Be compassionate and non-judgmental
- Remind users to consult healthcare providers for medical decisions

Keep responses concise, friendly, and actionable.`,
};
